
/* injects from baggage-loader */

'use strict';

const moduleEditorNavSections = angular.module('editorNavigationSections.controller', []);

moduleEditorNavSections.controller('EditorNavigationSections', [
  '$scope', 'editorNavSections', '$rootScope', 'Section', '$timeout', 'SectionEmail', 'SectionLesson', "$filter",
  ($scope, editorNavSections, $rootScope, Section, $timeout, SectionEmail, SectionLesson, $filter) => {
    $scope.sectionsCollection = [];
    $scope.categories = [];
    $scope.elementsCurrentTab = 'widgets';
    $scope.openTab = function(tab) {
      $scope.elementsCurrentTab = tab;
    };

    const bindDragDrop = function() {
      $timeout(function() {
        editorNavSections.bindDragSectionsInCollection();
      });
    };
    const destroyDragDrop = function() {
      editorNavSections._destroyBindDragSectionsInCollection();
      editorNavSections.destroyDropSections();
    };

    $rootScope.$on('open:tab', function(e, tab) {
      $scope.openTab(tab);
    });

    $scope.getSections = function(cb, categoryName) {
      destroyDragDrop();
      $scope.sectionsCollection = [];

      if (Editor.mode === 'lesson.page.editor') {
        SectionLesson.getCollection(categoryName, $scope.site.colors).then(function(sectionsData) {
          cb(sectionsData.sections);
          bindDragDrop();
        });
      } else if (Editor.mode === 'email.page.editor') {
        SectionEmail.getCollection(categoryName, $scope.site.colors).then(function (sectionsData) {
          cb(sectionsData.sections);
          bindDragDrop();
        });
      } else {
        Section.getCollection(categoryName, $scope.site.colors).then(function(sectionsData) {
          cb(sectionsData.sections);
          if (Editor.mode === 'editor.section') {
            return false;
          }
          bindDragDrop();
        });
      }
    };

    $scope.removeSection = function(index, section, sections) {
      return $rootScope.alertDialog({
        title: $filter('translate')('alert.publicSection.removeTitle'),
        text: $filter('translate')('alert.publicSection.removeDescription'),
        accept_text: $filter('translate')('alert.confirm'),
        cancel_text: $filter('translate')('alert.cancel'),
        accept: function() {
          if (index > -1) {
            Section.removePublic(section.id);
            return sections.splice(index, 1);
          }
        }
      });
    };

    const getCategories = function() {
      if ($rootScope.site) {
        if (Editor.mode === 'site.page.editor') {
          Section.getCategories($rootScope.site.id).then(function(data) {
            $scope.categories = data;
          });
        }
        if (Editor.mode === 'email.page.editor') {
          SectionEmail.getCategories($rootScope.site.id).then(function(data) {
            $scope.categories = data;
          });
        }
        if (Editor.mode === 'lesson.page.editor') {
          SectionLesson.getCategories($rootScope.site.id).then(function(data) {
            $scope.categories = data;
          });
        }
      }
    };

    $scope.editorAccordion = function(e) {
      var thisElement, thisSection;
      thisElement = angular.element(e.target);
      thisSection = thisElement.siblings('.ms__section');
      if (thisElement.hasClass('ms__title_active')) {
        thisElement.removeClass('ms__title_active');
        thisSection.removeClass('ms__section_active');
      } else {
        thisElement.addClass('ms__title_active');
        thisSection.addClass('ms__section_active');
      }
    };

    $scope.getSectionsByCategory = function(category) {
      if (category.sections && category.sections.length > 0) {
        const hasNotUserSections = category.sections.findIndex(item => !!item.is_own_section) === -1;

        // Если в списке нет пользовательских секций, то не будем перезагружать секции
        if (hasNotUserSections) {
          return false;
        }
      }

      category.sectionsLoading = true;
      $scope.getSections(function(sectionsData) {
        category.sections = sectionsData;
        category.sectionsLoading = false;
      }, category.original_name);
    };

    $rootScope.getPublicSections = function(sectionsTag) {
      if (sectionsTag) {
        $scope.categories.forEach(function(category) {
          if (category.name === sectionsTag) {
            $scope.getSectionsByCategory(category);
          }
        });
        $scope.editorAccordion({
          target: $("[title='" + sectionsTag + "']")
        });
      }
      if ($scope.categories.length === 0) {
        getCategories();
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/editor_nav/sections/sections.controller.js